import { useCheckoutCartState } from '../../contexts/CheckoutCartContext';
import { useEffect, useState } from 'react';
import { ALCOHOL_TYPE } from '../../constants';

interface ICreatedUseProductInfosInCheckout {
  totalWeight: number;
  totalEconomy: number;
  compareAtPrice: number;
  containsAlcoholProducts: boolean;
  productCount: number;
  subTotalWithoutCoupon: number;
}

const createUseProductInfosInCheckout =
  (productService) => (): ICreatedUseProductInfosInCheckout => {
    const { checkoutCart } = useCheckoutCartState();
    const [products, setProducts] = useState([]);

    useEffect(() => {
      if (checkoutCart?.items?.length) {
        productService
          .getProductsBySku(checkoutCart.items.map(({ sku }) => sku))
          .then((product) => {
            setProducts(product);
          });
      }
    }, [checkoutCart]);

    const state = (checkoutCart?.items || []).reduce(
      (
        {
          totalEconomy,
          totalWeight,
          containsAlcoholProducts,
          productCount,
          compareAtPrice,
          subTotalWithoutCoupon,
        },
        { variantOriginalPrice, unitPrice, sku, variantWeight, quantity },
      ) => {
        const { product_type } = products.find(
          ({ sku: productSku }) => productSku === sku,
        ) || { product_type: '' };

        return {
          productCount: productCount + quantity,
          totalEconomy:
            variantOriginalPrice > 0
              ? totalEconomy +
                ((variantOriginalPrice - unitPrice) * quantity) / 100
              : totalEconomy,
          compareAtPrice:
            variantOriginalPrice > 0
              ? compareAtPrice + variantOriginalPrice * quantity
              : compareAtPrice,
          totalWeight: totalWeight + variantWeight * quantity,
          containsAlcoholProducts:
            containsAlcoholProducts || product_type === ALCOHOL_TYPE,
          subTotalWithoutCoupon:
            subTotalWithoutCoupon + (unitPrice * quantity) / 100,
        };
      },
      {
        totalWeight: 0,
        totalEconomy: 0,
        compareAtPrice: 0,
        containsAlcoholProducts: false,
        productCount: 0,
        subTotalWithoutCoupon: 0,
      },
    );

    return state;
  };

export default createUseProductInfosInCheckout;
